import { render, staticRenderFns } from "./SealShape.vue?vue&type=template&id=455f3155&scoped=true"
import script from "./SealShape.vue?vue&type=script&lang=js"
export * from "./SealShape.vue?vue&type=script&lang=js"
import style0 from "./SealShape.vue?vue&type=style&index=0&id=455f3155&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455f3155",
  null
  
)

export default component.exports